import { MetricLabel, type MetricLabelProps } from '@atlas/ui';
import { useEvidence } from '../EvidenceContext';

export function MetricExplainer({
  explainTitle,
  explainBody,
  glossaryTermId = 'glossary.costly-signals',
  ...metricProps
}: Omit<MetricLabelProps, 'glossaryTermId'> & {
  glossaryTermId?: string;
  explainTitle?: string;
  explainBody?: string;
}) {
  const { openEvidence } = useEvidence();

  return (
    <MetricLabel
      {...metricProps}
      onExplain={() =>
        openEvidence(
          explainTitle ?? metricProps.label,
          explainBody ?? `Interpretation and provenance for ${metricProps.label}.`,
        )
      }
      glossaryTermId={glossaryTermId}
    />
  );
}
